module.exports = __webpack_public_path__ + "img/illust01.9dafe056.png";